import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = () => _ctx.$router.push({ name: 'APIEditor' })),
          class: "btn btn-dark"
        }, " 新しくAPIを作成する "),
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiList, (api) => {
          return (_openBlock(), _createElementBlock("div", {
            key: api,
            class: "col-8 offset-2"
          }, [
            _createElementVNode("div", {
              onClick: () => _ctx.$router.push({ name: 'APIEditor', query: { id: api.id } }),
              style: {"cursor":"pointer","padding":"4px","margin":"1%"},
              class: "col-12 card"
            }, [
              _createElementVNode("b", null, _toDisplayString(api.path), 1)
            ], 8, _hoisted_6)
          ]))
        }), 128))
      ])
    ])
  ]))
}